import { LIVE_NFO, LIVE_NFO_ADD_MSG, LIVE_NFO_CLEAR_MSG, LIVE_NFO_ERROR, LIVE_NFO_HIDE_ERROR, LIVE_NFO_START_LOADER, LIVE_NFO_STOP_LOADER, } from "../interface/iLiveNFO";
const initState = {
    data: {
        type: null,
        list: [],
    },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
    message: {
        msg: "",
        show: false,
        icon: "",
    },
};
const liveNFOReducer = (state = initState, action) => {
    switch (action.type) {
        case LIVE_NFO:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case LIVE_NFO_ADD_MSG:
            return Object.assign(Object.assign({}, state), { message: action.payload.message });
        case LIVE_NFO_CLEAR_MSG:
            return Object.assign(Object.assign({}, state), { message: initState.message });
        case LIVE_NFO_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case LIVE_NFO_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case LIVE_NFO_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case LIVE_NFO_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default liveNFOReducer;
